<template>
    <!-- 联系我们首屏（随语言切换，仅展示当前语种） -->
    <main-page
        :title="title"
        :subtitle="subtitle"
        :description="description"
        :button-text="buttonText"
        :secondary-button-text="secondaryButtonText"
        secondary-button-href="https://t.me/LantonPaykefu"
        :bg="bg"
    />
</template>

<script>
import MainPage from '@/views/components/MainPage.vue'
export default {
    name: 'ContactUs',
    components: {
        MainPage
    },
    data() {
        return {
            bg: "/img/pay/0-_BG-6.png",
        }
    },
    computed: {
        title() {
            return this.$t('contact.title');
        },
        subtitle() {
            return this.$t('contact.subtitle');
        },
        description() {
            const desc = this.$t('contact.description', { returnObjects: true });
            return Array.isArray(desc) ? desc : [desc];
        },
        buttonText() {
            return this.$t('common.buttonText');
        },
        secondaryButtonText() {
            return this.$t('nav.contact');
        }
    }
}
</script>
